import { r as s, c as n, h as a, H as l } from "./main-bb89b2f2.js";
import { T as i } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
const r = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}:host{display:inline-block}.static{position:static}", o = r, h = class {
  constructor(e) {
    s(this, e), this.languageSelect = n(this, "lhLanguageSelect", 7), this._optionData = null, this.selectItemClick = (t) => {
      i.setLanguage(t.detail.selected), this.languageSelect.emit({ selected: t.detail.selected });
    }, this.placement = void 0, this.headerFirstRow = !1, this.options = void 0, this.selected = void 0, this.show = !1, this.width = "256px", this.isOpen = this.show;
  }
  async componentWillLoad() {
    var e;
    this.options == null ? this._optionData = i.getCoreLanguages().map((t) => ({ label: t.translatedLabel, value: t.languageCode, detail: `(${t.label})` })) : this.setOptions(this.options), this.selected == null && (this.selected = await i.getCurrentLanguage((e = this._optionData) === null || e === void 0 ? void 0 : e.map((t) => t.value))), i.setLanguage(this.selected), this.languageSelect.emit({ selected: this.selected });
  }
  arrayDataWatcher(e) {
    e != null && this.setOptions(e);
  }
  setOptions(e) {
    typeof e == "string" ? this._optionData = JSON.parse(e) : this._optionData = e;
  }
  onFlyoutOpen() {
    this.isOpen = !0;
  }
  onFlyoutClosed() {
    this.isOpen = !1;
  }
  render() {
    return a(l, { key: "f3aaa98ca83ddf33f9d2c2a925a82f1db33da014" }, a("patternlib-language-picker", { key: "6a71ef0a5ec28d0b0c89b7f489368adbb04a4c6b", placement: this.placement, width: this.width, show: this.show, selected: this.selected, options: this._optionData, onLhSelect: this.selectItemClick, headerFirstRow: this.headerFirstRow }));
  }
  static get watchers() {
    return {
      options: ["arrayDataWatcher"]
    };
  }
};
h.style = o;
export {
  h as patternlib_language_picker_service
};
